module.exports = __webpack_public_path__ + "components/flag/static/square/ch-b32ea8948bba60c8fadfeb9c333f0daa.svg";